import { connect } from 'react-redux';
import { Icon } from 'components/common/icons';

export default connect((state) => state)(({ messages, theme }) => (
  <noscript>
    <div className="noscript">
      <div className="container">
        <Icon icon="exclamation-triangle" style={{ marginRight: 10 }} />
        {messages.appNoscriptWarning}
      </div>

      <style jsx>{`
        .noscript {
          background-color: ${theme.dangerColor};
          color: ${theme.dangerTextColor};
          font-size: 1.4rem;
          font-weight: 600;
          padding: 10px 0;
          width: 100%;
        }
      `}</style>
    </div>
  </noscript>
));
